import request from "@/utils/request";

export async function get(tokenValue) {
  if (tokenValue) {
    return await request.get(`/orders/${tokenValue}?loyalty`, { data: null });
  }

  return await new Promise(resolve => {
    resolve({
      data: {},
    });
  });
}
